import axios from 'axios';
import { User } from '../interfaces/api/user';

export async function getUsers(): Promise<User[]> {
	try {
		const response = await axios.get<User[]>('api/users/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getUser(): Promise<User> {
	try {
		const response = await axios.get<User>('api/users/current/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
